<template>
  <a-avatar
    :size="size"
    class="kr-icon"
  >
    k{{ typeof index === 'undefined' ? 'r' : index }}
  </a-avatar>
</template>

<script>
export default {
  props: {
    index: {
      type: Number,
      default: undefined
    },
    size: {
      type: Number,
      default: 18
    }
  }
}
</script>

<style lang="less" scoped>
.kr-icon {
  display: block;
  background-color: #64B5F6;
}
</style>
